
Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};
Greenmile.PanelBuilder.BuildCard = function () {

    const now = new Date();
    const nowToIso = now.toISOString();
    const today =nowToIso.substring(0,10);

    const routeView = {
        "route": {
            "description": Monet.I18n.getResourcesByKey("SelectKeyResource.Route.description"),
            "organization": {
                "description": Monet.I18n.getResourcesByKey("route.organization")
            },
            "key": Monet.I18n.getResourcesByKey("SelectKeyResource.Route.key"),
            "date": today,
            "origin": {
                "description": Monet.I18n.getResourcesByKey("Route.origin.description")
            },
            "destination": {
                "description": Monet.I18n.getResourcesByKey("Route.destination.description")
            },
            "lastStopIsDestination": false,
            "baseLineArrival": nowToIso,
            "baseLineDeparture": nowToIso,
            "plannedArrival": nowToIso,
            "plannedDeparture": nowToIso,
            "projectedArrival": nowToIso,
            "projectedDeparture": nowToIso,
            "baseLineDistance": 61110,
            "actualDistance": 51110,
            "plannedDistance": 58871.69370270664,
            "projectedDistance": 20208.813916052128,
            "baseLineComplete": nowToIso,
            "plannedComplete": nowToIso,
            "projectedComplete": nowToIso,
            "lastContactTime": nowToIso,
            "actualStartDataQuality": "DRIVER_ENTERED",
            "actualDepartureDataQuality": "DRIVER_ENTERED",
            "actualDistanceDataQuality": "DRIVER_ENTERED",
            "actualCompleteDataQuality": "DRIVER_ENTERED",
            "baseLineCost": 55,
            "plannedCost": 0,
            "actualCost": 20,
            "baseLineStart": nowToIso,
            "plannedStart": nowToIso,
            "projectedStart": nowToIso,
            "actualStart": nowToIso,
            "actualDeparture": nowToIso,
            "actualArrival": nowToIso,
            "actualComplete": nowToIso,
            "hasHelper": true,
            "totalStops": 24,
            "redeliveredStops": 1,
            "actualDepartures": 20,
            "canceledStops": 3,
            "status": "NOT_STARTED",
            "plannedServiceTime": 16682000,
            "baselineServiceTime": 30686000,
            "actualSize1": 19.182,
            "actualSize2": 9.182,
            "actualSize3": 5459.845,
            "baselineSize1": 1556.917,
            "baselineSize2": 19.294,
            "baselineSize3": 11375.615000000002,
            "plannedSize1": 1556.917,
            "plannedSize2": 19.294,
            "plannedSize3": 11375.615000000002,
            "actualPickupSize1": 56,
            "actualPickupSize2": 1.893,
            "actualPickupSize3": 83.1,
            "baselinePickupSize1": 106,
            "baselinePickupSize2": 4.771,
            "baselinePickupSize3": 212.9,
            "plannedPickupSize1": 106,
            "plannedPickupSize2": 4.771,
            "plannedPickupSize3": 212.9,
            "hasGps": false
        },
        primaryAssignments: {
            "driver": {
                "login": Monet.I18n.getResourcesByKey("users.login"),
                "enabled": true,
                "key": Monet.I18n.getResourcesByKey("Filter.Order.PrimaryDriver.Key"),
                "name": Monet.I18n.getResourcesByKey("Filter.Order.PrimaryDriver.Name"),
                "unitSystem": "METRIC",
                "isSystem": false,
                "smartTrack": false
            },
            equipment: {
                "key": Monet.I18n.getResourcesByKey("Filter.Order.primaryEquipment.Keyr"),
                "equipmentType": {
                    "id": 10024,
                    "size1": 999999,
                    "size2": 19.6,
                    "size3": 7000
                },
                "description":  Monet.I18n.getResourcesByKey("route.primaryEquipment"),
                "enabled": true,
                "gpsUnitId": "581",
                "size1": 999999,
                "size2": 19.6,
                "size3": 7000
            }

        },
        secondaryAssignments: {
            "driver": {
                "login": Monet.I18n.getResourcesByKey("users.login"),
                "enabled": true,
                "key":  Monet.I18n.getResourcesByKey("kronosLog.driverKey"),
                "name": Monet.I18n.getResourcesByKey("routeview.secondaryDriver"),
                "unitSystem": "METRIC",
                "isSystem": false,
                "smartTrack": false
            },
            "equipment": {
                "key": Monet.I18n.getResourcesByKey("route.secondaryEquipment"),
                "equipmentType": {
                    "id": 10024,
                    "size1": 999999,
                    "size2": 19.6,
                    "size3": 7000
                },
                "description":  Monet.I18n.getResourcesByKey("route.secondaryEquipment"),
                "enabled": true,
                "gpsUnitId": "581",
                "size1": 999999,
                "size2": 19.6,
                "size3": 7000
            }
        },

        "depotDeparturePlannedTimeSecs": 10,
        "depotDepartureBaselineTimeSecs": 10,
        "depotDepartureActualTimeSecs": 12,
        "depotArrivalBaselineTimeSecs": 10,
        "depotArrivalPlannedTimeSecs": 10,
        "depotArrivalActualTimeSecs": 20,
        "totalActualTimeSecs": 12682,
        "totalPlannedTimeSecs": 16682,
        "totalBaselineTimeSecs": 30686,
        "totalOpenEventLogs": 10,
        "routePercentage": 87,
        "completeTimeDeviationSecs": 25559,
        "totalStopsInProgress": 1
    };

    this.filterFront = function (field) {
        return field.isFront;
    };

    this.filterBack = function (field) {
        return !field.isFront;
    };

    this.mapField = function (cardField) {
        return cardField.field.id;
    };

    this.validate = function (controller) {

        var fields = this.getValues();

        var elFront = this.cardBuilder.elFrontBuilder.querySelector(".MonetUIFilterBuilderSelectContainer");

        var fieldsIsFront = fields.filter(this.filterFront);

        if (fieldsIsFront.length === 0) {
            controller.allow_submit.errorMessages.push(
                Monet.Form.Messages.mountErrorMessageObject("panelbuilder.buildcard.frontmandatory"));

            controller.allow_submit.status = false;
            elFront.setAttribute("class", "MonetUIFilterBuilderSelectContainer RouteView control-group error");
        } else {
            elFront.setAttribute("class", "MonetUIFilterBuilderSelectContainer RouteView");
        }

        var backFields = fields.filter(this.filterBack)
            .map(this.mapField)
            .sort();

        var uniques = backFields.reduce(function (p, c) {
            if (p.indexOf(c) < 0) {
                p.push(c);
            }
            return p;
        }, []);

        var elBack = this.cardBuilder.elBackBuilder;

        if (uniques.length < backFields.length) {
            controller.allow_submit.errorMessages.push(Monet.Form.Messages.mountErrorMessageObject('panelbuilder.buildcard.backunique'));
            controller.allow_submit.status = false;
            elBack.setAttribute("class", elBack.className + "Card BackCard control-group error");
        } else {
            elBack.setAttribute("class", "Card BackCard");
        }

    };

    this.el = document.createElement("div");
    this.el.setAttribute('class', 'BuildCard');

    this.elBuilder = document.createElement("div");
    this.elBuilder.setAttribute('class', 'CardBuilder');

    this.elViewer = document.createElement("div");
    this.elViewer.setAttribute('class', 'CardViewer');

    this.cardViewer = new Greenmile.PanelBuilder.CardView;
    this.cardBuilder = new Greenmile.PanelBuilder.CardEdit(this.cardViewer.updateCard.bind(this.cardViewer), true);

    this.getValues = function () {

        return this.cardBuilder.getValue().map(function (cardField) {
            return cardField.getValue();
        }).filter(function (cardField) {
            return cardField.field.id;
        });

    };

    this.setValues = function (cardFields) {

        this.cardBuilder.setValues(cardFields);

        this.cardBuilder.fieldList.forEach(this.cardViewer.updateCard, this.cardViewer);

    };


    this.renderBuilder = function () {

        this.cardBuilder.createStructure(routeView);

        const cardContainer = document.createElement("div");
        cardContainer.className = 'cardLayout';

        const titleContainer = document.createElement("div");
        titleContainer.className = 'cardLayout__title';
        titleContainer.textContent = Monet.I18n.getResourcesByKey("PanelBuilder.cardLayout.title");

        var frontContainer = document.createElement("div");
        frontContainer.className = 'frontContainer';
        frontContainer.appendChild(this.cardBuilder.renderFrontalBuilder());

        var frontLabel = document.createElement("span");
        frontLabel.setAttribute('class', 'CardBottomLabel frontal');
        frontLabel.textContent = Monet.I18n.getResourcesByKey("PanelBuilder.cardFront");
        frontContainer.appendChild(frontLabel);

        var backContainer = document.createElement("div");
        backContainer.className = 'backContainer';
        backContainer.appendChild(this.cardBuilder.renderBackBuilder());

        var backLabel = document.createElement("span");
        backLabel.setAttribute('class', 'CardBottomLabel back');
        backLabel.textContent = Monet.I18n.getResourcesByKey("PanelBuilder.cardBack");
        backContainer.appendChild(backLabel);

        const swapBtnContainer = document.createElement("div");
        swapBtnContainer.className = 'cardLayout__swapBtn';
        swapBtnContainer.addEventListener('click', () => {
            this.flipCards();
        });

        cardContainer.appendChild(frontContainer);
        cardContainer.appendChild(backContainer);
        cardContainer.appendChild(swapBtnContainer);

        this.elBuilder.appendChild(titleContainer);
        this.elBuilder.appendChild(cardContainer);

        this.el.appendChild(this.elBuilder);

    };

    this.renderViewer = function () {

        this.cardViewer.createStructure(routeView);

        var cardContainer = document.createElement("div");
        cardContainer.className = 'cardContainer';

        const titleContainer = document.createElement("div");
        titleContainer.setAttribute('class', 'CardBottomLabel preview');
        titleContainer.textContent = Monet.I18n.getResourcesByKey("PanelBuilder.preview");

        const frontContainer = document.createElement("div");
        frontContainer.appendChild(this.cardViewer.renderFrontalView(routeView));
        var frontLabel = document.createElement("span");
        frontLabel.setAttribute('class', 'CardBottomLabel frontal');
        frontLabel.textContent = Monet.I18n.getResourcesByKey("PanelBuilder.cardFront");
        frontContainer.appendChild(frontLabel);

        const backContainer = document.createElement("div");
        backContainer.appendChild(this.cardViewer.renderBackView(routeView));
        var backLabel = document.createElement("span");
        backLabel.setAttribute('class', 'CardBottomLabel back');
        backLabel.textContent = Monet.I18n.getResourcesByKey("PanelBuilder.cardBack");
        backContainer.appendChild(backLabel);

        cardContainer.appendChild(frontContainer);
        cardContainer.appendChild(backContainer);

        this.elViewer.appendChild(titleContainer);
        this.elViewer.appendChild(cardContainer);

        this.el.appendChild(this.elViewer);
    };

    this.flipCards = () => {
        const cardBuilder = document.querySelector('.CardBuilder .cardLayout');
        const cardViewer = document.querySelector('.CardViewer .cardContainer');

        const cardBuilderChildrens = cardBuilder.childNodes;
        const cardViewerChildrens = cardViewer.childNodes;

        cardBuilder.insertBefore(cardBuilderChildrens[1], cardBuilderChildrens[1].previousElementSibling);
        cardViewer.insertBefore(cardViewerChildrens[1], cardViewerChildrens[1].previousElementSibling);

        this.reOrderCardsName();
    };

    this.reOrderCardsName = () => {
        const cardBuilder = document.querySelector('.CardBuilder .cardLayout');
        const cardViewer = document.querySelector('.CardViewer .cardContainer');

        const cardBuilderChildrens = cardBuilder.childNodes;
        const cardViewerChildrens = cardViewer.childNodes;

        const frontCardBuilderSpan = cardBuilderChildrens[1].previousElementSibling.childNodes[1];
        const backCardBuilderSpan = cardBuilderChildrens[1].childNodes[1];

        const frontCardViewerSpan = cardViewerChildrens[1].previousElementSibling.childNodes[1];
        const backCardViewerSpan = cardViewerChildrens[1].childNodes[1];

        frontCardBuilderSpan.textContent = Monet.I18n.getResourcesByKey("PanelBuilder.cardFront");
        backCardBuilderSpan.textContent = Monet.I18n.getResourcesByKey("PanelBuilder.cardBack");

        frontCardViewerSpan.textContent = Monet.I18n.getResourcesByKey("PanelBuilder.cardFront");
        backCardViewerSpan.textContent = Monet.I18n.getResourcesByKey("PanelBuilder.cardBack");
    }

    this. getSideCardToShow = () => {
        const cardBuilder = document.querySelector('.CardBuilder .cardLayout');

        const cardBuilderChildrens = cardBuilder.childNodes;
        if(cardBuilderChildrens[0].className === 'frontContainer') {
           return 'FRONT';
        } else {
            return 'BACK';
        }
    };

    this.render = function () {

        this.renderBuilder();
        this.renderViewer();

        return this.el;

    };

};